/* Enhancement of native Shopify sections; no commercial data or tracking. */
(()=>{
 const aliases={nuances:'couleurs',couleurs:'couleurs',stylo:'le-stylo',geste:'le-geste',questions:'questions'};
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 function setup(scope=document){
  scope.querySelectorAll('a[href^="/#teinte-"]').forEach(link=>{
   if(link.dataset.refletteColour)return;
   link.dataset.refletteColour='true';
   const card=link.closest('.card');if(!card)return;
   card.id=link.getAttribute('href').slice(2);
   link.setAttribute('aria-haspopup','dialog');
   link.addEventListener('click',event=>{
    if(typeof HTMLDialogElement==='undefined')return;
    event.preventDefault();
    const photo=card.querySelector('img');const name=card.querySelector('.title').textContent.trim();
    let dialog=document.getElementById('reflette-colour-dialog');
    if(!dialog){
     dialog=document.createElement('dialog');dialog.id='reflette-colour-dialog';dialog.className='reflette-colour-dialog';
     dialog.setAttribute('aria-labelledby','reflette-colour-title');
     dialog.innerHTML='<button type="button" class="reflette-dialog-close" aria-label="Fermer la couleur">×</button><div class="reflette-dialog-copy"><p class="subtitle">LA COLLECTION REFLETTE</p><h2 id="reflette-colour-title"></h2><p class="reflette-dialog-description"></p><a class="btn btn-primary" href="/#le-geste">Découvrir le geste</a></div>';
     const detailImage=new Image();detailImage.className='reflette-dialog-image';detailImage.src=photo.currentSrc||photo.src;detailImage.alt=name+' — manucure et stylo REFLETTE';dialog.insertBefore(detailImage,dialog.querySelector('.reflette-dialog-copy'));
     document.body.append(dialog);
     dialog.querySelector('button').addEventListener('click',()=>dialog.close());
     dialog.querySelector('a').addEventListener('click',()=>dialog.close());
     dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
    }
    dialog.querySelector('img').src=photo.currentSrc||photo.src;dialog.querySelector('img').alt=name+' — manucure et stylo REFLETTE';
    dialog.querySelector('h2').textContent=name;
    dialog.querySelector('.reflette-dialog-description').textContent=card.querySelector('.description').textContent.trim();
    dialog.showModal();
   });
  });
  Object.entries(aliases).forEach(([suffix,id])=>{
   const section=document.querySelector(`.shopify-section[id$="__${suffix}"]`);
   if(section&&!document.getElementById(id)){const anchor=document.createElement('span');anchor.id=id;anchor.className='reflette-anchor';anchor.setAttribute('aria-hidden','true');section.prepend(anchor);}
  });
  const opening=document.querySelector('.shopify-section[id$="__opening"]');
  scope.querySelectorAll('video').forEach(video=>{
   if(video.dataset.refletteReady)return;
   video.dataset.refletteReady='true';
   const film=video.closest('.video-wrapper');
   if(film){video.addEventListener('play',()=>film.classList.add('is-playing'));video.addEventListener('pause',()=>film.classList.remove('is-playing'));}
   const isOpening=opening?.contains(video);
   const wasAuto=video.hasAttribute('autoplay');
   if(!isOpening){video.preload='none';video.removeAttribute('autoplay');}
   if(reduced.matches||!video.getClientRects().length)video.pause();
   const io=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
     if(!entry.isIntersecting){video.pause();}
     else if((isOpening||wasAuto)&&!reduced.matches&&video.dataset.userPaused!=='true'&&video.getClientRects().length){video.play().catch(()=>{});}
    });
   },{threshold:.15});io.observe(video);
  });
  if(opening?.querySelector('video')&&!opening.querySelector('.reflette-pause')){
   const button=document.createElement('button');button.type='button';button.className='reflette-pause';button.textContent=reduced.matches?'Lire la vidéo':'Pause';
   button.setAttribute('aria-label',reduced.matches?'Lire la vidéo de présentation':'Mettre la vidéo de présentation en pause');
   button.addEventListener('click',()=>{
    const visible=[...opening.querySelectorAll('video')].filter(v=>v.getClientRects().length);
    const playing=visible.some(v=>!v.paused);
    visible.forEach(v=>{v.dataset.userPaused=playing?'true':'false';playing?v.pause():v.play().catch(()=>{});});
    button.textContent=playing?'Lire la vidéo':'Pause';button.setAttribute('aria-label',playing?'Lire la vidéo de présentation':'Mettre la vidéo de présentation en pause');
   });opening.querySelector('section')?.append(button);
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
 document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
